<template>
  <div class="event-handling-container">
    <!-- 标题区域 - 单独一行 -->
    <div class="event-title">
      <img src="@/assets/financial_right.png" alt="" style="width: 10px;height: 10px;vertical-align: bottom;padding-right: 5px;">
      {{ title }}
    </div>

    <!-- 内容区域 - options 和 event-list 并排 -->
    <div class="content-wrapper">
      
      <!-- 选项列表 -->
      <div class="options-list">
        <el-input placeholder="搜索申请标题、申请人" v-model="input3" class="input-with-select" prefix-icon="el-icon-search">
          <template slot="append">
            <div class="input-button" @click="handleSearch">查询</div>
          </template>
        </el-input>
        <div
            v-for="(item, index) in options"
            :key="index"
            :class="['option-item', { 'active': activeIndex === index }]"
            @click="handleOptionClick(index,item.estateId)"
        >
          <span class="" style="width: 8px;height: 8px;border-radius: 50%; margin-right: 10px;" :style="activeIndex === index ? 'background-color:#FF7200' : 'background-color:#00FFF7'"></span>
          <span class="option-text">{{ item.estateName }}</span>
          <i class="el-icon-arrow-right" v-if="activeIndex === index"></i>
        </div>
      </div>

      <!-- 事件列表组件 -->
      <div class="event-list-wrapper">
        <vueinfo ref="vueinfo" @onBack="onBack" v-if="is_info"></vueinfo>
        <vueeventlist ref="vueeventlist" @onDetail="onDetail" v-else></vueeventlist>
      </div>
    </div>
  </div>
</template>


<script>
import vueeventlist from './vueeventlist'
import vueinfo from './vueinfo'
import {Message} from "element-ui";
import {getAllEstate} from "@/api/estate";
import vuecommatrs from "@/views/event_intervention/vuecommatrs";
export default {
  data() {
    return {
      // parentActiveIndex: 0,
      activeIndex: 0,
      is_info:false,
      options: [],
      title:'资金申请',
      input3: '',
    };
  },
  components: {
    vueeventlist,
    vueinfo
  },
  methods: {
    onBack(){
      this.is_info = false
      setTimeout(() => {
        if (this._isDestroyed || !this.$refs.vueeventlist) return;
        this.$refs.vueeventlist.$emit('sync-option', this.activeIndex,this.options[this.activeIndex].estateId,this.input3);
      }, 500);
    },
    onDetail(id){
      // // console.log(id);
      if(id){
        this.is_info = true
        setTimeout(() => {
          if (this._isDestroyed || !this.$refs.vueinfo) return;
          this.$refs.vueinfo.$emit('onDetail', id);
        }, 500);
      }
    },
    handleSearch(){
      this.is_info = false
      setTimeout(() => {
        if (this._isDestroyed || !this.$refs.vueeventlist) return;
        this.$refs.vueeventlist.$emit('sync-option', this.activeIndex,this.options[this.activeIndex].estateId,this.input3);
      }, 500);
    },
    handleOptionClick(index,id) {
      this.is_info = false
      this.activeIndex = index;
      setTimeout(() => {
        if (this._isDestroyed || !this.$refs.vueeventlist) return;
        this.$refs.vueeventlist.$emit('sync-option', index,id,this.input3);
      }, 500);
    },
    // 查询物业
    queryEstate() {
      getAllEstate().then(res => {
        this.options = res.data;
        setTimeout(() => {
          if (this._isDestroyed || !this.$refs.vueeventlist) return;
          this.$refs.vueeventlist.$emit('sync-option', this.activeIndex,this.options[this.activeIndex].estateId,this.input3);
        }, 500);
      })
    }
  },
  created() {
    this.queryEstate()
    // 监听父组件传递的事件
    // this.$on('sync-option', (index) => {
    //   this.parentActiveIndex=index
    //   this.activeIndex=0
    //   this.options=[]
    //   this.queryEstate()
    // });
  },
};
</script>


<style scoped>
.event-handling-container {
  display: flex;
  flex-direction: column; /* 垂直排列：标题 + 内容 */
  width: 1600px;
  height: 840px;
  background-color: rgba(28,127,118,0.16);
  border-radius: 4px;
  overflow: hidden;
}

/* 标题样式 - 渐变背景 */
.event-title {
  display: flex;
  align-items: baseline;
  width: 300px;
  padding: 10px 15px;
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  background-image: linear-gradient(135deg, rgba(77, 241, 227, 0.6), rgba(44, 139, 131, 0));
  clip-path: polygon(0 0, 70% 0%, 100% 100%, 0 100%);
  flex-shrink: 0; /* 防止被压缩 */
}

.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
}

.options-list {
  width: 240px;
  padding: 10px;
}

.input-with-select {
  border: 1px solid #0EE0D4;
  background-color: rgba(77, 241, 227, 0.3);
  margin-bottom: 10px;
  border-radius: 4px;
  font-size: 13px;
}

.input-with-select ::v-deep .el-input__inner::placeholder {
  color: rgba(14, 224, 212, 1); /* 输入文字颜色 */
}

/* 修改 append 区域样式 */
.input-with-select :deep(.el-input-group__append) {
  background-color: rgba(255, 255, 255, 0) !important;
  border: none;
  color: #0EE0D4;
}

/* 修改搜索图标的颜色 */
.input-with-select :deep(.el-input__prefix) .el-input__icon {
  color: #0EE0D4; /* 设置你需要的颜色值 */
}

.input-with-select :deep(.el-icon-search) {
  color: #0EE0D4 !important;
  font-size: 16px; /* 调整图标大小 */
}

.input-button {
  padding: 3px 13px;
  border-radius: 30px;
  color: #fff;
  background: linear-gradient( 360deg, #00E0DC 0%, rgba(0,224,220,0.46) 30%, rgba(0,224,220,0.07) 64%, #00E0DC 100%);
}

.event-list-wrapper {
  flex: 1;
  padding: 10px;
  overflow: hidden;
}

/* 选项项基础样式 */
.option-item {
  display: flex;
  align-items: center;
  padding: 12px 10px;
  margin-bottom: 8px;
  color: #ffffff;
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
}

/* 选中状态样式 */
.option-item.active {
  background-color: rgba(0, 153, 153, 0.2);
  border-color: #00cccc;
}

/* 圆点样式 */
.blue-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #00ccff;
  margin-right: 10px;
}

.orange-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff9933;
  margin-right: 10px;
}

.option-text {
  flex: 1;
  font-size: 16px;
}

/* 箭头图标样式 */
.el-icon-arrow-right {
  color: #00cccc;
  font-size: 16px;
}
</style>
